import React from 'react';
import { MdEdit } from 'react-icons/md';
import { useHistory } from 'react-router';
import { IconButton, theme, useMediaQuery } from '@chakra-ui/react';

import { Agreement } from '@app/api/models/agreement';
import { entityBaseBodyRender } from '@app/components/common/table';

import { dateTimeBodyRender } from '../common/table/body-renders/date-time';
import { TableColumn } from '../common/table/types';

export const useColumns = (): TableColumn<Agreement>[] => {
  const isMdScreen = useMediaQuery(theme.breakpoints.md);
  const history = useHistory();
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'number',
      label: 'Номер',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Наименование',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'type',
      label: 'Тип',
      options: {
        filter: {
          name: 'type_id',
          sourceName: 'document_type',
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(),
      },
    },
    {
      name: 'outlet',
      label: 'Торговая точка',
      options: {
        filter: {
          name: 'outlet_id',
          type: 'outlet',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(),
      },
    },
    {
      name: 'distributor',
      label: 'Дистрибьютор',
      options: {
        filter: {
          name: 'distributor_id',
          sourceName: 'distributors',
          type: 'autocomplete',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(),
      },
    },
    {
      name: 'date_open',
      label: 'Дата заключения',
      options: {
        filter: {
          name: 'date_open',
          type: 'date',
          onApply: (value: string) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: dateTimeBodyRender(false, true),
      },
    },
    {
      name: 'date_close',
      label: 'Дата расторжения',
      options: {
        filter: {
          name: 'date_close',
          type: 'date',
        },
        sort: true,
        customBodyRender: dateTimeBodyRender(false, true),
      },
    },
    {
      name: 'id',
      label: 'Изм.',
      options: {
        hidden: !isMdScreen,
        filter: false,
        sort: false,
        customBodyRender: (id) => (
          <IconButton onClick={() => history.push('/agreements/edit/' + id)} aria-label="edit">
            <MdEdit />
          </IconButton>
        ),
      },
    },
    {
      name: 'serial_num',
      label: 'Серийный номер',
      options: {
        hidden: true,
        filter: true,
      },
    },
    {
      name: 'inventory_num',
      label: 'Инвентарный номер',
      options: {
        hidden: true,
        filter: true,
      },
    },
  ];
};
